module.exports = __webpack_public_path__ + "img/2.mobile.b319a735.png";